import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoVideo from 'eco-design/base/eco-video';
import styles from './index.module.scss';

const Energy: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('OceanProHomeSolarBattery.Energy');

    return (
        <div className={styles.Energy}>
            <div className="energy-container">
                <div className="energy-layout">
                    {/* <EcoSectionCommon title={t('title')} desc={t('desc')} /> */}
                    <div className="content">
                        <div className="title">{t('title')}</div>
                        <div className="desc">{t('desc')}</div>
                    </div>
                    <EcoVideo
                        pc={'https://websiteoss.ecoflow.com/upload/video/1755670041371/%E9%A3%9E%E4%B9%A620250820-140646.mp4'}
                        autoPlay={true}
                        loop={true}
                        poster="https://websiteoss.ecoflow.com/upload/image/1760325454709/Energy.jpg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Energy;
